import { IS_PRERENDER, PRERENDER_HOME_AS_LANDING } from "@/shared/lib/prerender";
/**
 * Что показать на "/": лендинг или студию.
 *
 * Гость и аноним получают лендинг СРАЗУ, без промежуточного лоадера — это и
 * первый экран для SEO, и самый частый случай. В студию уводит ТОЛЬКО
 * подтверждённая сессия (`isAuthenticated === true`, то есть /users/me уже
 * ответил 200).
 *
 * Раньше во время загрузки доверяли следу аккаунта в localStorage
 * (`hasAccountSession`) — это снимало вспышку лендинга у залогиненного, но
 * ломало протухшую сессию: флаг `isAuthenticated: true` остаётся в
 * persist-сторе навсегда, а кука умирает, и человек с "/" мгновенно улетал на
 * /generate-song гостем и лендинга не видел уже никогда. Корректность важнее
 * вспышки: пока идёт проверка сессии, рисуем лендинг.
 */
export const resolveHomeView = ({ isAuthenticated }) => isAuthenticated ? "studio" : "landing";
/**
 * Активен ли лендинг на текущем экране. Только на "/" и только когда
 * `resolveHomeView` выбрал лендинг.
 */
export const isLandingActive = ({ pathname, ...view }) => {
    if (pathname !== "/")
        return false;
    // Снимок пререндера главной — лендинг (сессии в пререндере нет, иначе в HTML
    // для поисковиков уехал бы экран генератора). Переключатель — один:
    // PRERENDER_HOME_AS_LANDING в shared/lib/prerender.ts.
    if (IS_PRERENDER && PRERENDER_HOME_AS_LANDING)
        return true;
    return resolveHomeView(view) === "landing";
};
